module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('h1', {
    attrs: {
      "id": "description"
    }
  }, [_vm._v(_vm._s(_vm.studio308.description))])]), _vm._v(" "), _c('div', {
    ref: "subsections",
    attrs: {
      "id": "sub-sections"
    }
  }, [_c('div', {
    staticClass: "sub-section align-left",
    attrs: {
      "id": "services"
    }
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('router-link', {
    attrs: {
      "to": 'services',
      "exact": ""
    }
  }, [_vm._v("Services")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "hover-light"
  }, [_vm._v("We want to help you out, and we do a lot of things, so odds are that what you need done matches up with what we're able to do. Whether you need help fleshing out your idea and how to implement it, or you need help building out what you've already planned, or you just need some things fixed and maintained, we've got you covered.")]), _vm._v(" "), _c('ul', {
    staticClass: "unstyled"
  }, _vm._l((_vm.menuServices), function(service, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": 'services' + service.hash,
        "exact": ""
      }
    }, [_vm._v(_vm._s(service.title))])], 1)
  }), 0)]), _vm._v(" "), (_vm.projects.length) ? _c('div', {
    staticClass: "sub-section align-right",
    attrs: {
      "id": "projects"
    }
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('router-link', {
    attrs: {
      "to": 'projects'
    }
  }, [_vm._v("Projects")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "hover-light"
  }, [_vm._v("Turning mere ideas into actual products is our passion. While we may not be landing launch rockets, yet, we love what we build. Whether it be web, mobile, or gaming, we dabble in what we find interesting and challenging, not taking on projects solely for their commercial value.")]), _vm._v(" "), _c('ul', {
    staticClass: "unstyled"
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('li', {
      key: index,
      on: {
        "click": _vm.scrollTop
      }
    }, [_c('router-link', {
      attrs: {
        "to": 'projects',
        "exact": ""
      }
    }, [_c('span', {
      staticClass: "side-notes"
    }, _vm._l((project.types), function(type, typeIndex) {
      return _c('span', {
        key: typeIndex,
        staticClass: "side-note"
      }, [_vm._v(_vm._s(type.title))])
    }), 0), _vm._v("\n            " + _vm._s(project.title) + "\n          ")])], 1)
  }), 0)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b7f2af0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 910
// module chunks = 1